import "./Loader.scss";
export function LargeLoader() {
  return <div className="loader-large"></div>;
}
export function SmallLoader() {
  return <div className="loader-small"></div>;
}
